// extracted by mini-css-extract-plugin
export var bodyCopy = "sideDownloadCta-module--bodyCopy--f42cc";
export var hasImage = "sideDownloadCta-module--hasImage--bfbfd";
export var headline = "sideDownloadCta-module--headline--af28e";
export var sideDownloadCta = "sideDownloadCta-module--sideDownloadCta--d5061";
export var thumbnail = "sideDownloadCta-module--thumbnail--c509f";